import React from "react"
import { Link, useLocation } from "react-router-dom"
import ClearAllPostBtn from "./ClearAllPostBtn"
import { useAuth, useAuthActions } from "../firebase/useAuth"
import { useStore } from "../context/context"
import kio_logo from "../assets/kio_logo.png"

export default function Header() {
  const [currentUser] = useAuth()
  const { logout } = useAuthActions({})
  const { responsive: { isScreenSmall } } = useStore()
  const location = useLocation()

  
	return (
		<header className="header">
      <Link to="/">
        <img src={kio_logo} style={{ width: 200 }} />
      </Link>
      <div className="connectedAs">Bienvenue, <b>{currentUser?.displayName}</b></div>
			<div className="headerRight">
        <ClearAllPostBtn isScreenSmall={isScreenSmall} />
        {location.pathname === "/settings" ? (
          <Link to="/">
            <div className="logoutBtn">Dashboard</div>
          </Link>
        ) : (
          <Link to="/settings">
            <div className="logoutBtn">Paramètres</div>
          </Link>
        )}
      </div>
		</header>
	)
}
